import { useCallback } from "react";
import { useFeatureFlagToggle } from "./useFeatureFlags";
import { useMessageToState } from "./useMessageToState";

export function useIsProductAdvancedEditMode() {
	const forceAdvancedEditMode = useFeatureFlagToggle("debugForceAdvancedEditMode");

	const getIsAdvancedEditMode = useCallback(
		(editor: eXpress.core.Editor) =>
			forceAdvancedEditMode || editor.isAdvancedViewLevel() || false,
		[forceAdvancedEditMode],
	);

	return useMessageToState({
		name: "useIsProductAdvancedEditMode",
		getState: getIsAdvancedEditMode,
		filterMessage: eXpress.core.isViewLevelChanged,
	});
}
